module.exports = __webpack_public_path__ + "static/media/RateTiger.2f1d0de6.png";